import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { getTickmillCompanyNameByType } from 'api/Clients/Types/TickmillCompanyTypes'
import { NameDto } from 'api/Common/Types'
import { MarketingCampaignKey } from 'api/Trading-Accounts/Types/MarketingCampaignDto'
import classNames from 'classnames'
import { formatLocalDateUTC } from 'utils/date'

import styles from '../Search/SearchGridResult.module.scss'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const campaignsColumn: GridColumn[] = [
  {
    title: 'Type',
    field: MarketingCampaignKey.type,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Start Date',
    field: MarketingCampaignKey.from,
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>{formatLocalDateUTC(props.dataItem.from, true)}</td>
    ),
    show: true,
    className: 'table-columns__date',
    filter: 'text',
  },
  {
    title: 'End Date',
    field: MarketingCampaignKey.to,
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>{formatLocalDateUTC(props.dataItem.to, true)}</td>
    ),
    show: true,
    className: 'table-columns__date',
    filter: 'text',
  },
  {
    title: 'Contests Status',
    field: MarketingCampaignKey.status,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Last Updated',
    field: MarketingCampaignKey.lastUpdatedDate,
    cell: (gridCellProps: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(gridCellProps.dataItem.lastUpdatedDate, true)}
      </td>
    ),
    show: true,
    className: 'transaction-columns__content',
    filter: 'text',
  },
  {
    title: 'Entity',
    cell: (props: GridCellProps): JSX.Element => {
      const tickmillCompanies = props.dataItem?.tickmillCompanies || []
      if (tickmillCompanies.length <= 0) {
        return <td />
      }

      return (
        <td className={classNames(styles.column)}>
          {tickmillCompanies.map((x: NameDto) => (
            <>
              <CompanyTag id={x.id}>{getTickmillCompanyNameByType(x.id)}</CompanyTag>{' '}
            </>
          ))}
        </td>
      )
    },
    show: true,
  },
]
